import React from "react";
import { useTranslation } from "react-i18next";

import MissionStep from "./MissionStep";

const CollapseHeader = (props) => {
  const { t } = useTranslation();

  const {
    className = 'w-full',
    title = '',
    percent = 5,
    collapseKeys = [],
    missionStep = {},
    Right = () => <></>
  } = props;

  return (
    <div className={className}>
      <div
        className="flex items-center justify-between"
        style={{width: 'calc(100% - 24px)'}}
      >
        <div className="flex items-center">
          <div>
            <div className="text-xl font-semibold">
              {title}
            </div>
            {
              collapseKeys.length === 0 && <span
                className="text-black-500 lg:hidden md:flex"
              > 
                {t('rewards.note2', { percent: percent })}
              </span>
            }
            {
              collapseKeys.length === 0 && <MissionStep
                className="lg:hidden md:flex"
                missionStep={missionStep}
              />
            }
            {
              collapseKeys.length > 0 && <Right
                className="lg:hidden md:block"
              />
            }
          </div>
          {
            collapseKeys.length === 0 && <span
              className="ml-4 text-black-500 lg:flex md:hidden hidden"
            >
              {t('rewards.note2', { percent: percent})}
            </span>
          }
        </div>
        <div className="flex items-center">
          {
            collapseKeys.length === 0 && <MissionStep
              className="lg:flex md:hidden hidden"
              missionStep={missionStep}
            />
          }
          {
            collapseKeys.length > 0 && <Right
              className="lg:block md:hidden hidden"
            />
          }
        </div>
      </div>
    </div>
  );
}

export default CollapseHeader;